/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AcknowledgedBy from './AcknowledgedBy/index'
import CancelAction from './CancelAction/index'
import IsAcknowledged from './IsAcknowledged/index'
import React from 'react'
import SubmitAction from './SubmitAction/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/AcknowledgePlatformFee/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 width={600}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Platform fee acknowledgment"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
 gap={dtSpaceM}
>
{childProps => (
<React.Fragment>
<IsAcknowledged
{...childProps}
  viewPath={`${viewPath}/IsAcknowledged`}
/>
<AcknowledgedBy
{...childProps}
  viewPath={`${viewPath}/AcknowledgedBy`}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<SubmitAction
{...childProps}
  viewPath={`${viewPath}/SubmitAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}